import { render, staticRenderFns } from "./indexScoreManage.vue?vue&type=template&id=42dbd382&scoped=true&"
import script from "./indexScoreManage.vue?vue&type=script&lang=js&"
export * from "./indexScoreManage.vue?vue&type=script&lang=js&"
import style0 from "./indexScoreManage.vue?vue&type=style&index=0&id=42dbd382&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dbd382",
  null
  
)

export default component.exports